import {
  DndContext,
  closestCenter,
  PointerSensor,
  TouchSensor,
  useSensor,
  useSensors
} from "@dnd-kit/core";

import {
  SortableContext,
  verticalListSortingStrategy,
  arrayMove,
} from "@dnd-kit/sortable";

import { useEffect, useState } from "react";
import SortableRow from "./SortableRow";
import { updateOrder } from "../api/RouteApi";

export default function DragDropTable({streetAddress, setStreetAddress, handleEdit, setDeleteIndex, setDeleteModal}) {

  const handleDragEnd = async(event) => {
  const { active, over } = event;

  if (!over || active.id === over.id) return;

  let updatedRows = [];

  setStreetAddress((items) => {
    const oldIndex = items.findIndex(i => i._id === active.id);
    const newIndex = items.findIndex(i => i._id === over.id);

    if (oldIndex === -1 || newIndex === -1) return items;

    const newItems = arrayMove(items, oldIndex, newIndex);

    updatedRows = newItems.map((item, index) => ({
      ...item,
      order: index,
    }));

    return updatedRows;
  });

  await updateOrder(
    updatedRows.map(r => ({
      id: r._id,
      order: r.order
    }))
  );
};

const sensors = useSensors(
  useSensor(PointerSensor, {
    activationConstraint: {
      distance: 8, // desktop drag threshold
    },
  }),
  useSensor(TouchSensor, {
    activationConstraint: {
      delay: 250,   // long-press
      tolerance: 5,
    },
  })
);


  return (
    <DndContext
    sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={handleDragEnd}
    >
      <table className="table table-bordered">
        <thead>
          <tr style={{ textAlign: "center" }}>
            <th>Drag</th>
            <th>Street Name</th>
            <th>Home Seq.</th>
            <th>Range Type</th>
            <th>Action</th>
          </tr>
        </thead>

        <SortableContext
          items={streetAddress.map(r => r._id)}
          strategy={verticalListSortingStrategy}
        >
          <tbody>
            {streetAddress.map((row) => (
              <SortableRow key={row._id} row={row} handleEdit={handleEdit} setDeleteIndex={setDeleteIndex} setDeleteModal={setDeleteModal}/>
            ))}
          </tbody>
        </SortableContext>
      </table>
    </DndContext>
  );
}
